import { useParams } from 'react-router-dom';
import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { ContractCreateEditProvider } from './context/contract-create-edit-context';
import { CreateEditContractComponent } from './contract-create-edit-component';

export function ContractCreateEditFactory() {
    // A chave reinicia o estado ao trocar de contrato pela rota
    const { contractId } = useParams();

    return (
        <BaseLayoutFactory>
            <ContractCreateEditProvider key={contractId ?? 'new'}>
                <CreateEditContractComponent />
            </ContractCreateEditProvider>
        </BaseLayoutFactory>
    );
}
